import React, { Fragment, useEffect, useState } from "react";
import { t } from "i18next";
import { useContextSelector } from "use-context-selector";
import Header from "../component/Header";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageSelect from "../component/LanguageSelect";
import MenuMobile from "../component/MenuMobile";
import BottomNavigation from "../component/BottomNavigation";
import Footer from "../component/Footer";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import whatsapp from "../assets/images/whatsapp.svg";
import telegram from "../assets/images/telegram.svg";
import ModalOpen from "../component/ModalOpen";

const Layout = ({ children }) => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const languageModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.languageModal;
  });
    const modalOpen = useContextSelector(AuthContext, (ctx) => {
    return ctx.modalOpen;
  });  const setModalOpen = useContextSelector(AuthContext, (ctx) => {
    return ctx.setModalOpen;
  });
  const menuModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.menuModal;
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    let timer = setTimeout(() => {
      setLoader(false);
    }, 400);
    return () => {
      clearTimeout(timer);
    };
  }, [location]);
  const [socialIcon, setSocialIcon] = useState({});

  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getSetting, {
      website: hostname,
    });
    if (data?.success) {
      setSocialIcon(data?.results);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <Fragment>
      {languageModal && (
        <div
          className="v-overlay v-overlay--active theme--light"
          style={{ "z-index": "201" }}
        >
          <div
            className="v-overlay__scrim"
            style={{
              opacity: "0.46",
              "background-color": "rgb(33, 33, 33)",
              "border-color": "rgb(33, 33, 33)",
            }}
          />
          <div className="v-overlay__content" />
        </div>
      )}
      {menuModal && (
        <div
          className="v-overlay v-overlay--absolute v-overlay--active theme--light"
          style={{ "z-index": "7" }}
        >
          <div
            className="v-overlay__scrim"
            style={{
              opacity: "0.46",
              "background-color": "rgb(33, 33, 33)",
              "border-color": "rgb(33, 33, 33)",
            }}
          />
          <div className="v-overlay__content" />
        </div>
      )}
       {modalOpen && (
        <div
          className="v-overlay v-overlay--active theme--dark"
          style={{ "z-index": "201" }}
        >
          <div
            className="v-overlay__scrim"
            style={{
              opacity: "0.46",
              "background-color": "rgb(33, 33, 33)",
              "border-color": "rgb(33, 33, 33)",
            }}
          />
          <div className="v-overlay__content" />
        </div>
      )}
      <div className="v-application--wrap">
        <div>
          <Header />
          <div className="body">
            {children}
            {!["login", "register"].includes(
              location?.pathname?.split("/")[1],
            ) && <Footer />}
          </div>
          {isEmpty(user) ? (
            !["login", "register"].includes(
              location?.pathname?.split("/")[1],
            ) && (
              <div className="bottom-navigator d-md-none">
                <div className="row bottom-navigator-before-login no-gutters">
                  <div
                    onClick={() => navigate("/register")}
                    className="bottom-navigator-before-login-first d-flex justify-center align-center no-gutters col col-6"
                  >
                    <b>{t("Singup")}</b>
                  </div>
                  <div
                    onClick={() => navigate("/login")}
                    className="bottom-navigator-before-login-second d-flex justify-center align-center no-gutters col col-6"
                  >
                    <b>{t("Login")}</b>
                  </div>
                </div>
              </div>
            )
          ) : (
            <BottomNavigation />
          )}

          {loader && (
            <div
              className="v-overlay v-overlay--active theme--light"
              style={{ "z-index": "300" }}
            >
              <>
                <div
                  className="v-overlay__scrim"
                  style={{
                    opacity: "0.8",
                    "background-color": "rgb(33, 33, 33)",
                    "border-color": "rgb(33, 33, 33)",
                  }}
                />{" "}
                <div class="v-overlay__content">
                  <div class="pulse">
                    <img
                      src="/assets/new/bb88_logo_w_sponsor.svg"
                      width="120"
                      height="120"
                    />
                  </div>
                </div>{" "}
              </>
            </div>
          )}
        </div>
      </div>{" "}
      {location?.pathname == "/" && (
        <div className="betbtn1">
          {socialIcon?.whatsappIcon !== "" && (
            <div
              onClick={() => {
                window.open(
                  socialIcon?.whatsappContent
                    ? "https://wa.me/" + socialIcon?.whatsappContent
                    : "https://wa.me/",
                  "_self",
                );
              }}
            >
              <img
                src={
                  socialIcon?.whatsappIcon
                    ? process.env.REACT_APP_API_BASE_URL +
                      socialIcon?.whatsappIcon
                    : whatsapp
                }
                alt=""
              />
            </div>
          )}
          {socialIcon?.telegramIcon !== "" && (
            <div
              onClick={() => {
                window.open(
                  socialIcon?.telegramContent
                    ? "https://t.me/" + socialIcon?.telegramContent
                    : "https://t.me/",
                  "_self",
                );
              }}
            >
              <img
                src={
                  socialIcon?.telegramIcon
                    ? process.env.REACT_APP_API_BASE_URL +
                      socialIcon?.telegramIcon
                    : telegram
                }
                alt=""
              />
            </div>
          )}{" "}
        </div>
      )}
      {menuModal && <MenuMobile />}
      {languageModal && <LanguageSelect />}
      {modalOpen && <ModalOpen setModalOpen={setModalOpen}/>}
    </Fragment>
  );
};

export default Layout;
